/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_View_TableInputs */



/**
* | output |
* | --- |
* | "Table" |
*
* @param {Usage_View_TableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_view_table = /** @type {((inputs?: Usage_View_TableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_View_TableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tableau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tavolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mesa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("桌子")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テーブル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेज़")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mesa")
	return /** @type {LocalizedString} */ ("Table")
});